export const darkModeTitle = {
	id: 0,
	title: {
		en: {
			dark: "darkMode",
			light: "lightMode",
		},
		zh: {
			dark: "深色模式",
			light: "灯光模式",
		},
		ko: {
			dark: "다크 모드",
			light: "라이트 모드",
		},
	},
};
